import cybersecurity from './cybersecurity';
import header from './header';
import globals from '../globals';
import helpers from '../helpers';
import Scroll from './disable-scroll';

const $game = $('.kaspersky-inc-game');
const $wrapper = $game.find('.kaspersky-inc-game__wrapper');
const $screen = $game.find('.kaspersky-inc-game__screen');
const $intro = $screen.filter('.kaspersky-inc-game__screen--intro');
const $question = $screen.filter('.kaspersky-inc-game__screen--question');
const $answer = $screen.filter('.kaspersky-inc-game__screen--answer');
const $result = $screen.filter('.kaspersky-inc-game__screen--result');
const $button = $game.find('.kaspersky-inc-game__button');
const $count = $game.find('.kaspersky-inc-game__count');

const corrcetAnswers = [1, 1, 1, 1, 0, 0, 1, 0, 1, 1];
const questionsCount = $question.length;
const answersMultiplier = 100 / questionsCount;

let cybersecurityValue = 0;
let currentQuestion = 0;
let resultIndex = null;

function setMinHeightOnMobile() {
	if (helpers.isDesktop()) {
		$game
			.add($screen)
			.css('min-height', '');

		return;
	}

	$game
		.add($screen)
		.css('min-height', `${innerHeight}px`);
}

function toggleRules(state) {
	if (typeof state !== 'boolean') {
		return;
	}

	const $text = 	$screen.filter('.kaspersky-inc-game__screen--intro').find('.kaspersky-inc-game__text');
	const $firstText = $text.first();
	const $lastText = $text.last();

	if ($firstText.height() >= $lastText.height()) {
		$lastText.height($firstText.height());
	} else {
		$lastText.removeAttr('style');
	}

	$game.toggleClass('is-rules', state);
}

function setCount(currentValue, maxValue) {
	if (typeof currentValue !== 'number' || typeof maxValue !== 'number') {
		return;
	}

	currentValue = Math.abs(currentValue);
	currentValue = currentValue < 10 ? `0${currentValue}` : currentValue;
	maxValue = Math.abs(maxValue);
	maxValue = maxValue < 10 ? `0${maxValue}` : maxValue;

	const text = `${currentValue}/${maxValue}`;

	$count
		.find('span')
		.text(text);
}

function setActiveScreen($nextScreen, duration = 0.5, noScroll) {
	if (!$nextScreen) {
		return;
	}

	$nextScreen.removeClass('is-hidden');
	$game.height($nextScreen.outerHeight());

	const position = $nextScreen.position().top;

	gsap.to($wrapper, {
		onComplete() {
			$screen.removeClass('is-active');

			$nextScreen
				.addClass('is-active')
				.prevAll('.kaspersky-inc-game__screen')
				.addClass('is-hidden');

			gsap.set($wrapper, {clearProps: 'all'});
		},
		duration,
		y: -position,
	});

	if (noScroll) {
		return;
	}

	helpers.scrollTo($game.offset().top);
	Scroll.lock();
}

function reset() {
	cybersecurityValue = 0;
	currentQuestion = 0;
	resultIndex = null;

	header.setState('reset');
	cybersecurity.setValue(0);

	toggleRules(false);
	setCount(currentQuestion, questionsCount);

	gsap.killTweensOf($wrapper);
	gsap.set($wrapper, {clearProps: 'all'});

	$game
		.removeClass('is-rules is-share is-playing')
		.removeAttr('style');

	$wrapper.removeAttr('style');

	$screen
		.removeClass('is-active is-done')
		.addClass('is-hidden');

	$answer
		.find('.kaspersky-inc-game__title, .kaspersky-inc-game__text')
		.addClass('is-hidden');

	$result
		.find('.kaspersky-inc-game__title, .kaspersky-inc-game__text p')
		.addClass('is-hidden');

	helpers.scrollTo($game.offset().top);
}

function start() {
	if ($game.hasClass('is-playing')) {
		return;
	}

	header.hide().then(() => {
		header.setState('reset');
		header.setState('play');
		header.show();
	});

	cybersecurity.setValue(0);

	toggleRules(false);
	setCount(currentQuestion + 1, questionsCount);

	$game.addClass('is-playing');
	$intro.addClass('is-done');

	const $startQuestion = $question.eq(currentQuestion);

	setActiveScreen($startQuestion);
	Scroll.lock();
}

function answer($answerButton) {
	if (!$answerButton || $answerButton.closest('.kaspersky-inc-game__screen--question').hasClass('is-done')) {
		return;
	}

	const $currentQuestion = $question.eq(currentQuestion);
	const $currentAnswer = $answer.eq(currentQuestion);
	const $currentAnswerText = $currentAnswer.find('.kaspersky-inc-game__text');

	const answerButtonIndex = $answerButton.index();

	$currentQuestion.addClass('is-done');

	$currentAnswer
		.find('.kaspersky-inc-game__title')
		.eq(answerButtonIndex)
		.removeClass('is-hidden');

	$currentAnswerText
		.eq($currentAnswerText.length > 1 ? answerButtonIndex : 0)
		.removeClass('is-hidden');

	cybersecurityValue += (answerButtonIndex === corrcetAnswers[currentQuestion] ? 1 : -1) * answersMultiplier;

	cybersecurity.setValue(cybersecurityValue);

	setActiveScreen($currentAnswer);
}

function nextQuestion() {
	const $currentQuestion = $question.eq(currentQuestion);

	if (!$currentQuestion.hasClass('is-done')) {
		return;
	}

	const $currentAnswer = $answer.eq(currentQuestion);

	$currentAnswer.addClass('is-done');

	currentQuestion++;

	setCount(currentQuestion + 1, questionsCount);

	const $nextQuestion = $question.eq(currentQuestion);

	setActiveScreen($nextQuestion);
	Scroll.lock();
}

function result() {
	header.hide().then(() => {
		header.setState('reset');
		header.setState('finish');
		header.show();
		
		Scroll.unlock();
	});

	const middleValue = questionsCount / 2 * answersMultiplier;

	resultIndex = 0;

	if (cybersecurityValue >= 0 && cybersecurityValue <= middleValue) {
		resultIndex = 1;
	} else if (cybersecurityValue > middleValue) {
		resultIndex = 2;
	}

	const $currentAnswer = $answer.eq(currentQuestion);

	$game.removeClass('is-playing');
	$currentAnswer.addClass('is-done');

	$result
		.find('.kaspersky-inc-game__title')
		.eq(resultIndex)
		.removeClass('is-hidden');

	$result
		.find('.kaspersky-inc-game__text p')
		.eq(resultIndex)
		.removeClass('is-hidden');

	setActiveScreen($result);
}

async function replay() {
	await header.hide();

	gsap.to($game, {
		onComplete() {
			reset();
			setMinHeightOnMobile();

			header.show();

			setActiveScreen($intro, 0.25);
		},
		duration: 0.3,
		opacity: 0,
		clearProps: 'opacity',
	});
}

function getResult() {
	return resultIndex;
}

function resize() {
	const $currentScreen = $screen.filter('.is-active');

	setMinHeightOnMobile();
	setActiveScreen($currentScreen);
}

setMinHeightOnMobile();

$button.on('click', (e) => {
	e.preventDefault();
	e.stopPropagation();

	const $currentButton = $(e.currentTarget);

	if ($currentButton.hasClass('kaspersky-inc-game__button--rules-open')) {
		toggleRules(true);

		header.disable(true);
	} else if ($currentButton.hasClass('kaspersky-inc-game__button--rules-close')) {
		toggleRules(false);

		header.disable(false);
	} else if ($currentButton.hasClass('kaspersky-inc-game__button--share-open')) {
		$game.addClass('is-share');

		header.disable(true);
	} else if ($currentButton.hasClass('kaspersky-inc-game__button--share-close')) {
		$game.removeClass('is-share');

		header.disable(false);
	} else if ($currentButton.hasClass('kaspersky-inc-game__button--play')) {
		start();
	} else if ($currentButton.hasClass('kaspersky-inc-game__button--answer')) {
		answer($currentButton);
	} else if ($currentButton.hasClass('kaspersky-inc-game__button--next')) {
		if (currentQuestion + 1 === questionsCount) {
			result();
		} else {
			nextQuestion();
		}
	} else if ($currentButton.hasClass('kaspersky-inc-game__button--replay')) {
		replay();
	}
});

const showIntro = () => {
	header.show();
	setActiveScreen($intro, 0.25, true);
}

globals.$window
	.data('width-game', innerWidth)
	.on('load', () => {
		setTimeout(() => {
			showIntro();
		}, 500);
	})
	.on('resize', () => {
		helpers.resize('game', resize);
	});

globals.$document.on('keydown', (e) => {
	if ($game.hasClass('is-rules') || $game.hasClass('is-share') && e.keyCode === 27) {
		$game.removeClass('is-rules is-share');

		header.disable(false);
	}
});
if (document.readyState === "complete" || document.readyState === "interactive") {
	showIntro();
}
export default {
	getResult,
};
